export default __webpack_public_path__ + "static/new-bear-animation-9b6ca52b960bf61d1daea563336644cb.svg";